// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21 21"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M19.117 19.858l1.106-1.106a.942.942 0 00.004-1.328l-3.895-3.895a.937.937 0 00-.664-.273h-.637a8.085 8.085 0 001.719-5A8.124 8.124 0 008.625.131 8.124 8.124 0 00.5 8.256a8.124 8.124 0 008.125 8.125c1.887 0 3.621-.64 5-1.719v.637c0 .25.098.488.273.664l3.895 3.895a.934.934 0 001.324 0zM8.625 13.256c-2.762 0-5-2.234-5-5 0-2.762 2.234-5 5-5 2.762 0 5 2.234 5 5 0 2.762-2.234 5-5 5z"
            />
        </svg>
    );
};

export default React.memo(Search);
